import { useTranslation } from 'react-i18next';

import { Carousel, CarouselSlide } from './Carousel';

import authCarousel1 from '@/assets/auth-carousel-1.jpg';
import authCarousel2 from '@/assets/auth-carousel-2.jpg';
import authCarousel3 from '@/assets/auth-carousel-3.jpg';

export function AuthCarousel() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'components.AuthCarousel',
  });

  const authCarouselData = [
    {
      id: 1,
      url: authCarousel1,
      alt: t('alt1'),
      description: t('description1'),
    },
    {
      id: 2,
      url: authCarousel2,
      alt: t('alt2'),
      description: t('description2'),
    },
    {
      id: 3,
      url: authCarousel3,
      alt: t('alt3'),
      description: t('description3'),
    },
  ];

  return (
    <Carousel
      className="h-full rounded-lg"
      autoplay
      pagination={{ enabled: true }}
    >
      {authCarouselData.map((image) => (
        <CarouselSlide key={image.id}>
          <div className="relative h-full">
            <img
              className="h-full w-full object-cover"
              src={image.url}
              alt={image.alt}
            />

            <div className="absolute bottom-[68px] left-1/2 w-full max-w-[800px] -translate-x-1/2 px-20">
              <h3 className="text-center text-2xl uppercase text-white">
                {image.description}
              </h3>
            </div>
          </div>
        </CarouselSlide>
      ))}
    </Carousel>
  );
}
